import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { getOverallSettingsClasses, loadScrollMagic } from "../../utils/siteUtils";
import { BackgroundImage, BodyText, Icon } from "../../elements";
import PrimaryButton from "../../elements/primary-button";
import { mobileIs } from "../../utils/siteUtils";
import { englishMonthTimer } from '../../utils/date-utils';
import "./style.scss";
import gsap from 'gsap';

const KeywordDisplay = props => {
	const { lang, rendering, fields, page } = props;
  const { pc_image, m_image, pc_text, m_text, pc_model_image, m_model_image } = fields;
  const isMobile = mobileIs()
  const isAR = page?.fields?.rtl?.value;
  const swiperEl = useRef(null)
  const swiper = useRef(null)
  const rootNode = useRef()
  const paginationEl = useRef()
  const imageEl = useRef()
  const textEl = useRef()
  const emptyEl = useRef()
  const modelEl = useRef()

  useEffect(() => {
    let ScrollMagic, controller, scene, tl
    ScrollMagic = loadScrollMagic()
    controller = new ScrollMagic.Controller()
    tl = gsap.timeline()

    tl.add(gsap.to(imageEl.current, {
      scale: 1,
    }), 1)
    .add(gsap.to(modelEl.current, {
    	opacity: 1,
    }), 2)
    .add(gsap.to(textEl.current, {
      y: 0,
    }), 2)
    .add(gsap.to(emptyEl.current, {
      width: 1000
    }), 3)
    
    scene = new ScrollMagic.Scene({
      triggerElement: rootNode.current,
      triggerHook: 0,
      offset: 0,
      duration: window.innerHeight * 1.5
    })
    .setPin(rootNode.current)
    .setTween(tl)
    .addTo(controller)

    return () => {
      scene.destroy(true);
      scene = null;
      controller.destroy(true);
      controller = null;
    };
  }, [])

  const rootClasses = classNames("c-keyword-display", getOverallSettingsClasses(fields));
  return (
    <div className={rootClasses} datasourceid={rendering.dataSource} ref={rootNode}>
      <div className="c-keyword-display__image-content" ref={imageEl}>
        {!isMobile && <BackgroundImage {...pc_image} className="c-keyword-display__image-content__image" />}
        {isMobile && <BackgroundImage {...m_image} className="c-keyword-display__image-content__image" />}
      </div>
    	<div className="c-keyword-display__model" ref={modelEl}></div>
    	<div className="c-keyword-display__text-content" ref={textEl}>
    		{!isMobile && pc_text.value && !pc_model_image?.value?.src && <RichText tag="div" className="c-keyword-display__text-content__text" field={pc_text} />}
        {isMobile && m_text.value && !m_model_image?.value?.src && <RichText tag="div" className="c-keyword-display__text-content__text" field={m_text} />}
        {!isMobile && pc_model_image?.value?.src && <BackgroundImage {...pc_model_image} className="c-keyword-display__text-content__image" />}
        {isMobile && m_model_image?.value?.src && <BackgroundImage {...m_model_image} className="c-keyword-display__text-content__image" />}
    	</div>
      <div className="empty" ref={emptyEl}></div>
    </div>
  );
};

export default 	KeywordDisplay;